// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".productPromo--alertbox{background-color:#ffe9d1}.productPromo__popover{-webkit-margin-start:8px;margin-inline-start:8px}", ""]);
// Exports
module.exports = exports;
